/*
  Timer
*/
export const convertSecMin = (value: number): number => {
  return Math.round(value / 60);
};

/*
  Volume
*/
export const convertLToGal = (value: number): number => {
  return parseFloat((value / 3.785).toFixed(3));
};

export const convertGalToL = (value: number): number => {
  return parseFloat((value * 3.785).toFixed(3));
};

export const convertLocaleLToGal = (locale = "en-us", value: number): number => {
  return locale === "en-us" ? convertLToGal(value) : parseFloat(value.toFixed(3));
};

export const convertLocaleGalToL = (locale = "en-us", value: number): number => {
  return locale === "en-us" ? parseFloat(value.toFixed(3)) : convertGalToL(value);
};

/*
  Massa
*/
export const convertKgToPounds = (value: number): number => {
  return parseFloat((value * 2.205).toFixed(3));
};

export const convertPoundsToKg = (value: number): number => {
  return parseFloat((value / 2.205).toFixed(3));
};

export const convertLocaleKgToPounds = (locale = "en-us", value: number): number => {
  return locale === "en-us" ? convertKgToPounds(value) : parseFloat(value.toFixed(3));
};

export const convertLocalePoundsToKg = (locale = "en-us", value: number): number => {
  return locale === "en-us" ? parseFloat(value.toFixed(3)) : convertPoundsToKg(value);
};
